import "./App.css";
import Header from "./components/Header";
import SectionOne from "./components/SectionOne";
import LoginPopUp from "./components/LoginPopUp";
import { state } from "./client/store";
import { useSnapshot } from "valtio";
import AffiliatePanel from "./pages/AffiliatePanel";
import Loading from "./components/Loading";
import SuccessPopUp from "./components/SuccessPopUp";

function App() {
  const snap = useSnapshot(state);
  return (
    <div>
      <Header />
      <SectionOne />
      {snap.loginModal ? <LoginPopUp /> : null}
      {snap.isLoading ? <Loading /> : null}
      {snap.successModal ? <SuccessPopUp /> : null}

      {/* <AffiliatePanel /> */}
    </div>
  );
}

export default App;
